import { Alert, Box, Button, Snackbar, useMediaQuery } from "@mui/material";
import { useLayoutEffect, useState } from "react";
import dayjs from "dayjs";
import { useMetersStore } from "../../../store/meters.store";
import {
    MeterToSend,
    ReadingDataWithID,
} from "../../../types/Store/MetersStore.types";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../utils/components/Loading";
import MetersScoreboard from "./MetersScoreboard";

import "dayjs/locale/ru";

dayjs.locale("ru");

export function MetersPage() {
    const { getMeters, getReadings, readings, sendMeters, meters } =
        useMetersStore();
    const [hasErrors, setHasErrors] = useState<any>([]);
    const [changedMeter, setChangedMeter] = useState<ReadingDataWithID>({});
    const navigate = useNavigate();
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [sendLoading, setSendLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);

    const isSmallMobile = useMediaQuery("(max-width: 700px)")

    const isSubmissionPeriod = dayjs().date() >= 10 && dayjs().date() <= 25;

    useLayoutEffect(() => {
        (async () => {
            try {
                setPageLoading(true);
                await getMeters();
                await getReadings();
            } catch (error) {
            } finally {
                setPageLoading(false);
            }
        })();
    }, []);

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const handleChangeMeters = (id: number, value: number, file?: File) => {
        // enqueueSnackbar({ message: value.toString(), variant: "success" });
        setChangedMeter({
            ...changedMeter,
            [id]: {
                value,
                file: file || null,
            },
        });
    };

    const handleSendMeters = async () => {
        const dataToSend: Array<MeterToSend> = Object.keys(changedMeter).map(
            (n) => {
                return {
                    meter_id: Number(n),
                    value: changedMeter[n]?.value || 0,
                    file: changedMeter[n].file || null,
                };
            }
        );
        try {
            setSendLoading(true);
            const successed = await sendMeters(dataToSend);
            if (successed) {
                await getMeters();
                await getReadings();
                setOpenSnackbar(true);

                // Обнуление всех значений счётчиков
                setChangedMeter((prevState) => {
                    return Object.fromEntries(
                        Object.entries(prevState).map(([key, item]) => [
                            key,
                            {
                                ...item,
                                value: 0,
                                file: null,
                            },
                        ])
                    );
                });
            }
        } catch (error) {
        } finally {
            setSendLoading(false);
        }
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: isSmallMobile ? "stretch" :"center",
                    justifyContent: "space-between",
                    marginBottom: "30px",
                    maxWidth:"100%",
                    flexDirection: isSmallMobile ? "column" : "row"
                }}
            >
                <h1 style={{
                    fontSize: isSmallMobile ? "24px" : "auto"
                }}>Передача показаний</h1>
                {!pageLoading && meters.length > 0 && (
                    <Button
                        variant="contained"
                        onClick={() => navigate("/admin/meters/history")}
                    >
                        История показаний
                    </Button>
                )}
            </Box>
            {!isSubmissionPeriod && (
                <Alert severity="warning" sx={{ marginBottom: "20px" }}>
                    Передача показаний доступна с 10 по 25 числа каждого месяца
                </Alert>
            )}
            {pageLoading ? (
                <>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Loading />
                    </Box>
                </>
            ) : (
                <>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "40px",
                            maxWidth:"100%"
                        }}
                        
                    >
                        {readings
                            .filter(
                                (n) => n?.meter?.is_active !== false
                            )
                            .map((n) => {
                            return (
                                <MetersScoreboard
                                    data={n}
                                    handleChangeMeters={handleChangeMeters}
                                    changedMetersValue={changedMeter}
                                    setHasErrors={setHasErrors}
                                />
                            );
                        })}
                    </Box>
                    {readings.filter((n) => n?.meter?.is_active !== false).length > 0 ? (
                        <Box display={"flex"} justifyContent={"flex-end"}>
                            <Button
                                color="success"
                                sx={{ marginTop: "16px" }}
                                variant="contained"
                                onClick={handleSendMeters}
                                disabled={
                                    !isSubmissionPeriod ||
                                    sendLoading ||
                                    Object.values(hasErrors).includes(true)
                                }
                            >
                                Отправить
                            </Button>
                        </Box>
                    ) : (
                        <h2>У вас нет счётчиков</h2>
                    )}
                </>
            )}
            <Snackbar
                open={openSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                autoHideDuration={5000}
                onClose={handleCloseSnackbar}
            >
                <Alert
                    sx={(theme) => ({
                        border: "1px solid",
                        borderColor: theme.palette.primary.main,
                    })}
                >
                    Успешно переданы все значения!
                </Alert>
            </Snackbar>
        </Box>
    );
}
